/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUnitsForMerchantRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetUnitsForMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const getUnitsForMerchant = (request: GetUnitsForMerchantRequest, options?: CashRequestOptions) => post<GetUnitsForMerchantRequest, GetUnitsForMerchantResponse>("/2.0/cash/get-units-for-merchant", request, {...options, rejectOnError: true })